import { render, staticRenderFns } from "./MainNavigationView.vue?vue&type=template&id=03878972&scoped=true&"
import script from "./MainNavigationView.vue?vue&type=script&lang=ts&"
export * from "./MainNavigationView.vue?vue&type=script&lang=ts&"
import style0 from "./MainNavigationView.vue?vue&type=style&index=0&id=03878972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03878972",
  null
  
)

export default component.exports